import { Grid, Skeleton } from '@mui/material';

const ScanLoading = () => {
  return (
    <Grid container padding={'10px'}>
      <Grid item xs={12}>
        <Skeleton
          variant="rectangular"
          animation={'wave'}
          sx={{
            borderRadius: '4px',
            width: '126px',
            height: '32px',
            margin: 'auto'
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <Skeleton
          variant="circle"
          animation={'wave'}
          sx={{
            borderRadius: '50%',
            width: '80px',
            height: '80px',
            margin: '55px auto 64px auto'
          }}
        />
      </Grid>
      {[...Array(2)].map((_) => (
        <Grid item xs={12} pt={1}>
          <Skeleton
            variant="rectangular"
            animation={'wave'}
            sx={{
              borderRadius: '98px',
              width: '90%',
              height: '25px',
              margin: '0 auto'
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default ScanLoading;
